// src/components/layout/TabBar.tsx

export type TabKey = 'config' | 'calc' | 'compare' | 'roster';

const TABS: { key: TabKey; label: string }[] = [
  { key: 'config', label: '配置' },
  { key: 'calc', label: '计算' },
  { key: 'roster', label: '队伍' },
];

interface TabBarProps {
  active: TabKey;
  onChange: (key: TabKey) => void;
}

export function TabBar({ active, onChange }: TabBarProps) {
  return (
    <div className="flex gap-1 bg-slate-900 p-1 rounded-lg">
      {TABS.map((t) => (
        <button
          key={t.key}
          onClick={() => onChange(t.key)}
          className={`px-4 py-1.5 text-sm rounded-md transition ${
            active === t.key
              ? 'bg-primary-600 text-white font-medium'
              : 'text-slate-400 hover:text-white hover:bg-slate-800'
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}